export const COMPANIES_INVENTORY_ACTION = {
  VIEW: 'COMPANIES_INVENTORY_VIEW',
  PRODUCTS: 'COMPANIES_INVENTORY_PRODUCTS'
};